import API from '@/services/http'
import { guideUrl } from '@/services/url'
import type { ISubAccountInfo } from '@/store/serviceProviderSlice/types'

interface CancellationRequestType {
  /**邮箱 */
  email?: string
  /**来源系统 */
  applySource: 'ONESHIP_CROSS_BORDER_DASH' | 'ONESHIP_INTERNATIONAL_DASH' | 'ONESHIP_VN_DASH'
  /**图形验证码 */
  captchaToken: string
}

interface CancelConfirmType {
  ticket: string
  code: string
}

type IGetSubAccount = {
  expressTypeCode: string
  pickupType?: 1 | 2 //1:pickup；2:dropoff
}
/**
 * 获取子账号
 * @param params
 * @returns
 */
export const getSubAccount = (params: IGetSubAccount) => API.admin.post<ISubAccountInfo>('/api/user/sub_account/get', params)

export interface checkEmailTypeRes {
  sellerName: string
  /**
   * 1个人用户
   */
  userType: string
  token: string
}

export interface CountryCheckRes {
  countryCode: string
}

export interface IInfoProps {
  oneshipName: string
  notificationEmail?: string
}

export interface Premission {
  accessControl: 0 | 1
  resourceId: string
  system: string
  resourceCode: string
  resourceUrl: string
  children: Premission[]
  resourceName: string
  /** 是否禁用 */
  banned: 0 | 1
  /** 优先级（数字越大优先级越高） */
  priority: number
  /** ant插件key */
  key: string
  parentId: string
  /** 资源类型(1-菜单，2-功能) */
  resourceType: 1 | 2
}

/**
 * 更新用户信息
 * @returns
 */
export const updateUserInfo = (data: IInfoProps) => API.admin.post('/api/user/info/update', data)

/** 校验code */
export const verifyLoginCode = (data) => API.udb.get<{ code: string }>('/udb/lgn/login/verifyCode.do', { params: data })

/**
 * 商家注销-获取用户注册邮箱
 * @returns
 */
export const getCancellationEmail = () => API.toast.post<{ email: string }>('/api/user/info/getCancellationEmail')

/**
 * 商家注销申请
 * @returns
 */
export const doCancellation = (data: CancellationRequestType) => API.toast.post('/api/user/info/cancellation', data)

/**
 * 个人隐私申诉确认
 * @param data
 * @returns
 */
export const doAppealConfrim = (data: CancelConfirmType) => API.toast.post('/api/appeal/confirm', data)

/**
 * 商家注销确认
 * @param data
 * @returns
 */
export const doSellerCancelConfrim = (data: CancelConfirmType) => API.toast.post('/api/user/info/cancellationConfirm', data)
/** 校验ticket */
export const verifyLoginTicket = (data) => API.udb.get<{ code: string }>('/udb/lgn/cas/callback.do', { params: data })

/** 获取新手任务 */
export const fetchGuideInfoApi = () => API.admin.post(guideUrl.taskListUrl)

/** 不再提醒 */
export const neverRemindApi = () => API.admin.post(guideUrl.neverRemindUrl)

/** 全部完成 */
export const finishTask = () => API.admin.post(guideUrl.finishTaskUrl)

export const finishStepByStep = () => API.admin.post(guideUrl.finishStepsUrl, { guideTaskType: 'TRACK_SETTING_GUIDE_TASK' })

export const getUserPermissionTree = () => API.admin.post<{ extMap: any; resourceTree: Premission[] }>('/api/auth/resource/list')

export interface UserSettingListType {
  /** 来源国家地区 */
  sourceCountry?: string
  /** 配置编码列表 */
  settingCodes?: string[]
}

export interface UserSettingListResType {
  extMap?: Record<string, any>
  settings: {
    settingCode: string
    dataType: any
    dataValue: string
  }[]
}

/**
 * 获取用户设置
 * @param params
 * @returns
 */
export const getUserSetting = (params?: UserSettingListType) =>
  API.admin.post<UserSettingListResType>('/api/user/setting/list', params, {
    params: {
      // 为了匹配预请求
      settingCodes: params?.settingCodes?.join(','),
    },
  })
